import React, { useState } from 'react';
import MainLayout from '../../layout/mainlayout.tsx';
import { useParams } from 'react-router-dom';
import ContentHeader from '../../components/ContentHeader/ContentHeader.tsx';
import TicketTabs from '../../components/TicketPageComponents/TicketTabs/TicketTabs.tsx';
import TicketMainCard from '../../components/TicketPageComponents/TicketMainCard/TicketMainCard.tsx';
import TicketUpdateForm from '../../components/TicketPageComponents/TicketUpdateForm/TicketUpdateForm.tsx';
import TicketHistory from '../../components/TicketPageComponents/TicketHistory/TicketHistory.tsx';
import TicketAssignment from '../../components/TicketPageComponents/TicketAssignment/TicketAssignment.tsx';
import ClientProfile from '../../components/TicketPageComponents/ClientProfile/ClientProfile.tsx';
import AddNotePopup from '../../components/TicketPageComponents/AddNotePopup/AddNotePopup.tsx';
import { useGetTicketDetailsQuery } from '../../services/ticket.api.ts';
import './TicketDetails.css';

const TicketPage = () => {
  const { ticket_id } = useParams();
  const [activeTab, setActiveTab] = useState('ticket');
  const [isNotePopupOpen, setIsNotePopupOpen] = useState(false);

  const { 
    data: ticketDetailsResponse, 
    isLoading, 
    isError 
  } = useGetTicketDetailsQuery(Number(ticket_id), { skip: !ticket_id });

  if (isLoading) return <MainLayout>Loading...</MainLayout>;
  if (isError) return <MainLayout>Error loading ticket details</MainLayout>;
  if (!ticketDetailsResponse) return <MainLayout>No ticket found</MainLayout>;

  const { ticket } = ticketDetailsResponse;

  return (
    <MainLayout>
      <div className="ticket-details-page">
        <ContentHeader>Ticket ID: {ticket_id}</ContentHeader>
        
        <TicketTabs 
          activeTab={activeTab} 
          setActiveTab={setActiveTab}
          onAddNote={() => setIsNotePopupOpen(true)}
        />

        {isNotePopupOpen && (
          <AddNotePopup 
            ticketId={ticket_id}
            onClose={() => setIsNotePopupOpen(false)}
          />
        )}

        <div className="ticket-page-body">
          <div className="main-content-section">
            <div className="ticket-top-section">
              <TicketMainCard ticket={ticket} />
              <TicketUpdateForm />
            </div>
            
            <div className="ticket-bottom-section">
              <TicketHistory 
                histories={ticketDetailsResponse.histories}
                notes={ticketDetailsResponse.notes}
              />
              <TicketAssignment ticketId={ticket_id} />
            </div>
          </div>

          <ClientProfile client={ticket.client} />
        </div>
      </div>
    </MainLayout>
  );
};

export default TicketPage;